import React, { useState, useEffect } from 'react'

const ImageCycle = (props) => {
    return (
        <>
            {props.images.map((element, key) => <img key={key} src={element} onMouseEnter={props.onMouseEnter} onMouseLeave={props.onMouseLeave} style={{ display: key == props.displayingImage ? 'block' : 'none' }} />)}
        </>
    )
}

const ImageFlicker = (props) => {
    const images = props.images;
    const [isRotating, setIsRotating] = useState(true);
    const [displayingImage, setDisplayingImage] = useState(props.images.length - 1);

    useEffect(() => {
        let intervalId;
        if (isRotating) {
            intervalId = setInterval(() => {
                return changeDisplayingImage(isRotating);
            }, props.interval);
        }
        return () => {
            clearInterval(intervalId)
        };
    }, [isRotating])

    const handleOnMouseEnter = () => setIsRotating(false);
    const handleOnMouseLeave = () => setIsRotating(true);

    const changeDisplayingImage = (isRotating) => {
        if (isRotating) {
            setDisplayingImage((displayingImage) => (images.length - 1 === displayingImage) ? 0 : displayingImage + 1);
        }
        return isRotating;
    }

    return (
        <div>
            <ImageCycle images={images} displayingImage={displayingImage} onMouseEnter={handleOnMouseEnter} onMouseLeave={handleOnMouseLeave} />
        </div>
    )
}

export default ImageFlicker